//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getOrderPaymentInfo } from '@api/order.service'

export default {
  name: 'OrderStateInfo',
  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      paymentInfo: null,
      isLoad: false,
    }
  },
  mounted() {
    this.fetchPaymentInfo()
  },
  methods: {
    async fetchPaymentInfo() {
      this.isLoad = true
      try {
        const { data } = await getOrderPaymentInfo.execute({ id: this.orderId })
        this.paymentInfo = data.props.operation_info
        this.isLoad = false
      } catch (error) {
        this.isLoad = false
        console.error('Failed to fetch payment info:', error)
      }
    },
  },
}
